import { css } from '@emotion/react';
import { Button } from 'components/Button';
import { FormControl } from 'components/FormControl';
import { FormLine } from 'components/FormLine';
import { Select } from 'components/Select';
import { Toggle } from 'components/Toggle';
import { Controller, useForm } from 'react-hook-form';

enum FORM_EXPORT {
	CALENDAR_ID = 'calendarId',
	EXPORT_PRICES = 'exportPrices',
}

export const ExportToGoogleCalendarForm = ({
	calendarOptions,
	calendarApi,
	isExporting,
	onSubmit,
	onRefresh,
}) => {
	const {
		handleSubmit,
		control,
		formState: { errors },
	} = useForm();

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			css={css`
				width: 100%;
				display: flex;
				flex-direction: column;
			`}
		>
			<div
				css={css`
					margin-bottom: 12px;
				`}
			>
				<FormLine>
					<FormControl
						required
						label="Exportovat ceny?"
						htmlFor={FORM_EXPORT.EXPORT_PRICES}
						labelWidth={160}
						spaceMedium
					>
						<Controller
							name={FORM_EXPORT.EXPORT_PRICES}
							control={control}
							defaultValue={true}
							render={({ field }) => {
								return <Toggle marginBottom0 {...field} />;
							}}
						/>
					</FormControl>
				</FormLine>
				<FormLine>
					<FormControl
						required
						label="Datum"
						htmlFor={FORM_EXPORT.CALENDAR_ID}
						labelWidth={160}
						error={errors[FORM_EXPORT.CALENDAR_ID]}
					>
						<div
							css={css`
								display: flex;
								width: 100%;
								align-items: center;
							`}
						>
							<Controller
								name={FORM_EXPORT.CALENDAR_ID}
								control={control}
								rules={{ required: 'Vyberte kalendář.' }}
								render={({ field }) => {
									return (
										<Select
											options={calendarOptions || []}
											onChange={field.onChange}
											value={field.value}
											placeholder="Vyberte kaledář..."
											filterable
											error={errors[FORM_EXPORT.CALENDAR_ID]}
										/>
									);
								}}
							/>

							<Button small ghost onClick={onRefresh}>
								Aktualizovat
							</Button>
						</div>
					</FormControl>
				</FormLine>
			</div>

			<Button large block type="submit" isProcessing={isExporting}>
				Exportovat
			</Button>
		</form>
	);
};
